import type { FC } from 'react';

import type { BankConnection as BankConnectionType } from '@api-client/address-book';

import { formatPhoneNumber } from './BankConnectionWithSecondaryIdService';
import { BankConnection } from '../bankConnection/BankConnection';

interface Props {
    bankConnection: BankConnectionType;
}

export const BankConnectionWithSecondaryId: FC<Props> = ({ bankConnection }) => {
    const { secondaryId, ...restBankConnection } = bankConnection;

    if (secondaryId?.type === 'PHONE') {
        return <div>{formatPhoneNumber(secondaryId.id)}</div>;
    }

    return <BankConnection bankConnection={restBankConnection} />;
};
